import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResponseError } from 'models/common/respone.model';
import { RoleMaster } from 'models/role';

export function useDeleteMasterRole(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        RoleMaster
    >
) {
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('WF_APPLICATION');
            return axios.delete('/v1/configuration/workflow/role', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                params: {
                    sid: request.sid,
                    id: request.id,
                    menu_id: request.menu_id
                }
            });
        },
        ...options
    });
}
